"use client";
import moment from "moment";
import styles from "@/app/_components/Schedule/Schedule.module.css";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { EventItem } from "@/models/event-item";
import {
  filterEventsByDate,
  getUniqueDates,
} from "@/helpers/utils/utility-functions";
import { motion } from "framer-motion";

type DateFilterProps = {
  events: EventItem[];
  getdata: (index: number) => void;
  selected: number;
  seletectedEventId?: string;
};

export default function DateFilter({
  events,
  getdata,
  selected,
  seletectedEventId,
}: DateFilterProps) {
  const [selectedindex, setSelectedIndex] = useState(0);

  const handleDateSelected = useCallback(
    (index: number) => {
      getdata(index);
      setSelectedIndex(index);
    },
    [getdata]
  );

  const uniqueDates = useMemo(() => {
    return getUniqueDates(events);
  }, [events]);

  // find the selected index from the uniqueDates array

  useEffect(() => {
    if (!seletectedEventId) return;

    const selectedEvent = events.find(
      (event: EventItem) => event.id === seletectedEventId
    );

    if (selectedEvent) {
      const date = moment
        .unix(selectedEvent.startTime.seconds)
        .format("YYYY-MM-DD");
      const index = uniqueDates.indexOf(date);

      handleDateSelected(index);
    }
  }, [events]);

  events.forEach((event: EventItem) => {
    const date = moment.unix(event.startTime.seconds).format("YYYY-MM-DD");
    if (!uniqueDates.includes(date)) {
      uniqueDates.push(date);
    }
  });

  const formattedDates = uniqueDates.map((date: string) => {
    const inputDate = moment(date, "YYYY-MM-DD");
    const formattedDate = inputDate.format("MMM DD");
    const day = inputDate.format("ddd");
    return `${day}, ${formattedDate}`;
  });

  return (
    <>
      <div
        className="pl-[1.875rem]
        h-[80px] flex overflow-x-scroll no-scrollbar gap-2 md:gap-5 pt-2 mb-4 md:pt-5"
      >
        {formattedDates &&
          formattedDates.map((formattedDate: string, index: any) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: -10 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="flex cursor-pointer date-filter"
              onClick={() => handleDateSelected(index)}
            >
              <div
                className={`flex justify-center items-center border ${
                  selectedindex == index
                    ? "bg-[var(--Neutrals-Main-Neutral---Limed-Spruce)] text-[var(--Neutrals-Secondary-Neutral---White)]"
                    : "border-[var(--Neutrals-Gray-4)]"
                } rounded-full w-[8.875rem] h-[20px] p-[1.125rem] space-x-5 flex-shrink-0`}
              >
                <span className="text-[0.875rem] font-semibold tracking-[0.0175rem]">
                  {formattedDate}
                </span>
              </div>
            </motion.div>
          ))}
      </div>
    </>
  );
}
